export const normalizeLocalizeCodes = (arr, propertyName) => {
  if (arr && propertyName) {
    return arr.reduce((previousValue, currentValue) => {
      const fieldName = currentValue.name;
      const fieldValue = currentValue[propertyName];

      return {
        ...previousValue,
        [fieldName]: fieldValue,
      };
    }, {});
  }
};

export const normalizeFieldValues = (fieldValues, localizedFields) => {
  if (fieldValues && localizedFields) {
    const localizedFieldsObj = normalizeLocalizeCodes(localizedFields, 'code');

    return Object.fromEntries(
      Object.entries(fieldValues).map(([key, value]) => {
        if (localizedFieldsObj[key]) {
          return [localizedFieldsObj[key], value];
        }
        return [key, value];
      })
    );
  }
};

export const normalizeObjectValue = (objectValue, localizedObjects) => {
  if (objectValue && localizedObjects) {
    return normalizeLocalizeCodes(localizedObjects, 'id')[objectValue] || objectValue;
  }
};

export const isObject = item => item && typeof item === 'object' && !Array.isArray(item);

export const mergeDeep = (target, ...sources) => {
  if (!sources.length) {
    return target;
  }
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
};

export const unflat = data => {
  if (data) {
    const result = [];

    Object.keys(data).forEach(flatKey => {
      const keys = flatKey.split('_');

      let unftn = {
        [keys[keys.length - 1]]: keys.length === 1 ? { val: data[flatKey] } : data[flatKey],
      };
      for (let i = keys.length - 1; i--; ) {
        unftn = { [keys[i]]: unftn };
      }
      result.push(unftn);
    });

    return mergeDeep({}, ...result);
  }
};



// WEBPACK FOOTER //
// ./src/Shared/Helpers/JourneyBuilderHelper.js